export function identity(v) {
    return v;
}
//# sourceMappingURL=function.js.map